import {DateTime, Interval} from "luxon";
import {useQuery} from "react-query";
import ngage from "../services/ngage";
import {CalendarView} from "../pages/Event/Schedule/EventSchedule";
import {PER_PAGE_DAY, PER_PAGE_MONTH, PER_PAGE_WEEK} from "../services/prefetchEvents";
import {formattedDateTime} from "../services/date";

function determinePerPage(calendarView: CalendarView) {
  switch(calendarView) {
    case "day":
      return PER_PAGE_DAY
    case "week":
      return PER_PAGE_WEEK
    case "month":
      return PER_PAGE_MONTH
  }
}

export function useCalendarItems(selectedDate: DateTime, calendarView: CalendarView, siteId: number | null, typeId: number | null) {
  let startDate: DateTime = DateTime.now()
  let endDate: DateTime = DateTime.now()
  let dateIntervals: Interval[]

  if (calendarView === 'day') {
    // Get the date for the selected day
    startDate = selectedDate.startOf('day')
    endDate = selectedDate.endOf('day')
  }

  if (calendarView === 'week') {
    // Get the dates for the start and end of the week
    startDate = selectedDate.startOf('week')
    endDate = selectedDate.endOf('week')
  }

  if (calendarView === 'month') {
    // Get the start and end date including days from the previous month and next month
    startDate = selectedDate.startOf('month').startOf('week')
    endDate = selectedDate.endOf('month').endOf('week')
  }

  // Create an interval from the start and end dates in order to generate each day in the calendar date range
  dateIntervals = Interval.fromDateTimes(startDate, endDate).splitBy({ days: 1 })

  // Fetch events from the API
  const queryKey = ['events.between', {start: startDate.toISODate(), end: endDate.toISODate(), siteId, typeId}]
  const {data: eventList, isLoading, refetch: refetchEvents, isFetching: isFetchingEvents, dataUpdatedAt} = useQuery(
    queryKey,
    async ({signal}) => ngage.events.between(startDate, endDate, 1, determinePerPage(calendarView), siteId, typeId, {signal}),
  )

  const eventListSorted = eventList?.data.sort((a, b) => a.starts_at.valueOf() - b.starts_at.valueOf());
  const eventsUpdatedAt = formattedDateTime(DateTime.fromMillis(dataUpdatedAt));

  return { dateIntervals, eventList: eventListSorted, isLoading, queryKey, refetchEvents, isFetchingEvents, eventsUpdatedAt}
}